'use client'

import { type ReactNode, useRef } from 'react'
import { useResponsiveBehavior } from 'responsive/hooks/useResponsiveBehavior/useResponsiveBehavior'
import { env } from 'utils/envManager/envManager'

import { BannerWrapper } from '../../../BannerWrapper/BannerWrapper'
import styles from '../MangoLikesYouBanner.module.css'

const mlyAnimationUrl = new URL(
	'/videos/mangoLikesYou/mly-home-acquisition.mp4',
	env.NEXT_PUBLIC_SITE_BASE_URL
).href

const SIZE_SMALL = 263
const SIZE_MEDIUM = 384
const SIZE_LARGE = 401

const animationResponsiveBehavior = {
	default: {
		width: SIZE_SMALL,
		height: SIZE_SMALL,
	},
	medium: {
		width: SIZE_MEDIUM,
		height: SIZE_MEDIUM,
	},
	large: {
		width: SIZE_LARGE,
		height: SIZE_LARGE,
	},
	xlarge: {
		width: SIZE_LARGE,
		height: SIZE_LARGE,
	},
}

export interface MangoLikesYouImageProps {
	readonly className?: string
	readonly isPrioritySlot: boolean | undefined
}

export function MangoLikesYouAnimation({
	className,
	isPrioritySlot,
}: MangoLikesYouImageProps): ReactNode {
	const wrapperRef = useRef<HTMLDivElement>(null)
	const { width, height } = useResponsiveBehavior<{
		width: number
		height: number
	}>(animationResponsiveBehavior)

	return (
		<BannerWrapper
			ref={wrapperRef}
			priority={isPrioritySlot}
			className={className}
		>
			<video
				className={styles.video}
				width={width}
				height={height}
				autoPlay={true}
				playsInline={true}
				loop={true}
				muted={true}
				tabIndex={-1}
				aria-hidden
			>
				<source src={mlyAnimationUrl} type='video/mp4' />
				<track kind='captions' default />
			</video>
		</BannerWrapper>
	)
}
